module.exports = __webpack_public_path__ + "static/climate_card_img4@2x-190fb14d785f348ded08eac9e4010bb5.jpg";